import { render, staticRenderFns } from "./TruPoint.vue?vue&type=template&id=597869a4&scoped=true"
import script from "./TruPoint.vue?vue&type=script&lang=js"
export * from "./TruPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597869a4",
  null
  
)

export default component.exports